// extracted by mini-css-extract-plugin
export var active = "_gi-2";
export var recordingDot = "_gi-1";
export var recordingIndicator = "_gi-0";